import React from 'react';
import { Trans } from '@lingui/react';
import { FormattedMarkdown } from '@qover/react-intl';

export default {
  actionLabel: <Trans id="bike.discountBar.actionLabel" />,
  addDiscount: <Trans id="bike.discountBar.addDiscount" />,
  discount: <Trans id="bike.discountBar.discount" />,
  error: <Trans id="bike.discountBar.error" />,
  tooltip: <FormattedMarkdown id="bike.discountBar.tooltip" />,
  removeDiscount: (
    removeDiscount: React.DOMAttributes<HTMLAnchorElement>['onClick'],
  ) => (
    <FormattedMarkdown
      id="bike.discountBar.removeDiscount"
      defaults="bike.discountBar.removeDiscount [link](#)"
      options={{
        overrides: {
          a: (props: any) => <a {...props} onClick={removeDiscount} />,
        },
      }}
    />
  ),
};
